<div class="filter-title">
  <div class="filter-name-wrapper" (click)="toggleFilter()" tabIndex="0" role="button" aria-hidden="true">
    @if (isCollapsable) {
      <rkt-icon class="filter-toggler" [name]="isCollapsed ? 'chevron-right' : 'chevron-down'"></rkt-icon>
    }
    <div class="filter-name">{{ filterName }}</div>
  </div>
  @if (selectedValue && selectedValue !== this.defaultValue) {
    <button rktButton btnType="danger" class="filter-reset-btn" (click)="onChange(this.defaultValue)">Reset</button>
  }
</div>

@if (!isCollapsed) {
  @for (option of options; track option; let i = $index) {
    <div class="rkt-form-radio">
      <label class="rkt-form-radio-label" [for]="id + '_' + i" [class.disabled]="option.disabled">
        <input
          hidden
          type="radio"
          [id]="id + '_' + i"
          class="rkt-form-radio-input"
          [name]="id"
          [attr.value]="option.value"
          [(ngModel)]="selectedValue"
          (change)="onChange(option.value)"
          [value]="option.value"
          [attr.disabled]="option.disabled ? true : null"
        />
        <div class="rkt-form-radio-icon"></div>
        <div class="rkt-form-radio-value">
          {{ option.label }}
        </div>
      </label>
      @if (isEditDateRangeAvailable && option.value === 'CUSTOM') {
        <button class="edit-icon" (click)="onEditClick(option.value)">
          <rkt-icon name="edit"></rkt-icon>
        </button>
      }
      @if (isEditCustomDateAvailable && option.value === 'CUSTOM_DATE') {
        <button class="edit-icon" (click)="onEditClick(option.value)">
          <rkt-icon name="edit"></rkt-icon>
        </button>
      }
    </div>
  }
  @if (selectedValue === 'CUSTOM' && fromDate && toDate && !fieldError) {
    <div class="selected-range-values">{{ fromDate }}&nbsp;-&nbsp;{{ toDate }}</div>
  }
  @if (selectedValue === 'CUSTOM_DATE' && customDate && !fieldError) {
    <div class="selected-range-values">
      {{ customDate }}
    </div>
  }
}
